import React from 'react';
import CallToActionBlockComponent, { type CallToActionBlockComponentProps } from 'content/CallToAction';

interface CallToActionBlockProps {
    data: CallToActionBlockComponentProps;
    theme?: CallToActionBlockComponentProps['theme'];
    imageLoading?: 'eager' | 'lazy';
}

const CallToActionBlock: React.FC<CallToActionBlockProps> = ({ data, theme, imageLoading = 'lazy' }) => (
    <CallToActionBlockComponent {...data} theme={theme ?? data.theme} imageLoading={imageLoading} />
);
export default CallToActionBlock;
